import React, { useContext, useEffect } from 'react';
import AuthContext from "context/autentication/authContext";
import UsuarioContext from 'context/usuario/usuarioContext';
import Dialogs from 'components/Dialog/Dialogs'
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import { Role } from "types/roles";
import {Menu,MenuItem} from "@material-ui/core/";
import { Link, useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    iconMenu: {
        color: "#fafafa"
    }
}));
const StyledMenuItem = withStyles((theme) => ({
    root: {
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                color: theme.palette.common.white,
            },
        },
    },
}))(MenuItem);

function HabilitarDeshabilitarSoporte({ anchorEl,setAnchorEl, setPulse, pulse}) {
    const classes = useStyles();
    const history = useHistory();
    const authContext = useContext(AuthContext);
    const usuariosContext = useContext(UsuarioContext);
    const {obtenerUsuarios, obtenerEstadoDeSoporte, soporteActivo} = usuariosContext;
    const { rol, usuario } = authContext;
    const [soporte, setSoporte] = React.useState(false);
    
    const [openSoporte, setOpenSoporte] = React.useState(false);

    const estadoSoporte = () => {
        setSoporte(!soporte) 
    }
    const setOpenSop = () => {
        setOpenSoporte(true)
    }
    const setCloseSop = () => {
        setOpenSoporte(false)
    }
   
    
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    //modificacines endpoint nuevo aca
    useEffect(() => {
        if (usuario) {
            obtenerEstadoDeSoporte()
            //obtenerUsuarios(usuario.clienteRol[0].cliente.clienteCreador).then(value => setSuport(value))            
        }
        // eslint-disable-next-line
    }, [usuario]);
     useEffect(() => {
        setSoporte(soporteActivo)
        
    }, [soporteActivo])
    useEffect(() => {
        setPulse(soporte)
        // eslint-disable-next-line
    }, [soporte]);

    const soporteEstado = () => {
        setOpenSop()
    }
    const setOpcion= (x) =>{
        console.log("X", x)
        if (x==="ayuda"){
            handleClose()
            window.open('/centro-de-ayuda', '_blank')
        }else if (x==="contactar") {
            handleClose()
        }
    }
    return (
        <>
        {rol === Role.Admin ?
            <>
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                     {!soporte ?
                        /* <MenuItem onClick={() => {setAnchorEl(null);soporteEstado();}}>Deshabilitar Asistencia Remota</MenuItem>
                        :*/
                       <MenuItem onClick={() => {setAnchorEl(null);soporteEstado();}}>Habilitar Asistencia Remota</MenuItem>
                    :
                        null
                    } 
                    <Link to={"/contacto"} style={{ textDecoration: "none", color:"black"}}>
                        <MenuItem onClick={() => setOpcion("contactar")}>Contactar</MenuItem>
                    </Link>
                    <div style={{ textDecoration: "none", color:"black"}}>
                        <MenuItem onClick={()=>setOpcion("ayuda")}>Centro de Ayuda </MenuItem>
                    </div>
                </Menu>
                <Dialogs open={openSoporte} handleClose={setCloseSop} titulo={"Soporte"} option={"soporte"} estado={soporte} funcion={estadoSoporte} />
            </> 
            : 
            <>
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    <Link to={"/contacto"} style={{ textDecoration: "none", color:"black"}}>
                        <MenuItem onClick={() => setOpcion("contactar")}>Contactar</MenuItem>
                    </Link>
                    <div style={{ textDecoration: "none", color:"black"}}>
                        <MenuItem onClick={()=>setOpcion("ayuda")}>Centro de Ayuda </MenuItem>
                    </div>
                </Menu>
            </> 
            }
        </>
    )
}
export default HabilitarDeshabilitarSoporte;